"use client";
import { jsx as n } from "react/jsx-runtime";
import { Icon as r } from "@zapier/zinnia-icons";
import k from "classnames";
const m = "_socialLinks_8yiq1_2", L = "_socialLink_8yiq1_2", e = {
  socialLinks: m,
  socialLink: L
}, b = {
  linkedin: { icon: "socialLinkedIn", label: "LinkedIn" },
  instagram: { icon: "socialInstagram", label: "Instagram" },
  facebook: { icon: "socialFacebook", label: "Facebook" },
  twitter: { icon: "socialX", label: "X (Twitter)" }
}, p = ({ socialLinks: a, authorName: l, testId: t }) => Object.values(a).some(Boolean) ? /* @__PURE__ */ n("div", { className: k(e.socialLinks), "data-testid": t, children: Object.entries(b).map(([i, { icon: c, label: s }]) => {
  const o = a[i];
  return o ? /* @__PURE__ */ n("a", { href: o, target: "_blank", rel: "noopener noreferrer", "aria-label": `${l} on ${s}`, title: s, className: e.socialLink, "data-testid": `social-${i}`, children: /* @__PURE__ */ n(r, { name: c, size: "16" }) }, i) : null;
}) }) : null;
export {
  p as SocialLinks
};
//# sourceMappingURL=SocialLinks.es.js.map
